import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";
import { EntityProfileIndustry, EntityProfileType } from "@common/types/entity";
import { ChartOfAccountsTemplatesViewColumn } from "@common/types/views/chartOfAccountsTemplatesView";
import { ViewConfig } from "@lib/views";
import { ChartOfAccountsTemplateActionsCell } from "./cells/ChartOfAccountsTemplateActionsCell";
import { ChartOfAccountsTemplateBasisCell } from "./cells/ChartOfAccountsTemplateBasisCell";
import { ChartOfAccountsTemplateChartCell } from "./cells/ChartOfAccountsTemplateChartCell";
import { ChartOfAccountsTemplateDescriptionCell } from "./cells/ChartOfAccountsTemplateDescriptionCell";
import { ChartOfAccountsTemplateEntitiesCell } from "./cells/ChartOfAccountsTemplateEntitiesCell";
import { ChartOfAccountsTemplateEntityTypeCell } from "./cells/ChartOfAccountsTemplateEntityTypeCell";
import { ChartOfAccountsTemplateIndustryCell } from "./cells/ChartOfAccountsTemplateIndustryCell";
import { ChartOfAccountsTemplateNameCell } from "./cells/ChartOfAccountsTemplateNameCell";
import { ChartOfAccountsTemplateStatusCell } from "./cells/ChartOfAccountsTemplateStatusCell";

export interface ChartOfAccountsTemplateRow {
    id: string;
    name: string;
    organizationId: string;
    basis: AccountingLedgerBasis[];
    industries: EntityProfileIndustry[];
    entityLegalType: EntityProfileType;
    hasCustomChartOfAccounts: boolean;
    description: string | null;
    appliedEntitiesCount: number;
    canDelete: boolean;
    archivedAt: Date | null;
}

export type ChartOfAccountsTemplatesViewConfig = ViewConfig<
    ChartOfAccountsTemplateRow,
    ChartOfAccountsTemplatesViewColumn,
    never
>;

export const chartOfAccountsTemplatesViewConfig: ChartOfAccountsTemplatesViewConfig =
    {
        columns: {
            [ChartOfAccountsTemplatesViewColumn.NAME]: {
                accessorKey: "name",
                name: "Template",
                header: "Template",
                cell: ChartOfAccountsTemplateNameCell,
                minSize: 220,
                maxSize: 1200,
            },
            [ChartOfAccountsTemplatesViewColumn.BASIS]: {
                accessorKey: "basis",
                name: "Basis",
                header: "Basis",
                cell: ChartOfAccountsTemplateBasisCell,
                minSize: 120,
                maxSize: 200,
            },
            [ChartOfAccountsTemplatesViewColumn.INDUSTRY]: {
                accessorKey: "industries",
                name: "Industry",
                header: "Industry",
                cell: ChartOfAccountsTemplateIndustryCell,
                minSize: 140,
                maxSize: 240,
            },
            [ChartOfAccountsTemplatesViewColumn.ENTITY_TYPE]: {
                accessorKey: "entityLegalType",
                name: "Entity type",
                header: "Entity type",
                cell: ChartOfAccountsTemplateEntityTypeCell,
                minSize: 160,
                maxSize: 240,
            },
            [ChartOfAccountsTemplatesViewColumn.CHART]: {
                accessorKey: "hasCustomChartOfAccounts",
                name: "Chart origin",
                header: "Chart origin",
                cell: ChartOfAccountsTemplateChartCell,
                minSize: 140,
                maxSize: 200,
            },
            [ChartOfAccountsTemplatesViewColumn.DESCRIPTION]: {
                accessorKey: "description",
                name: "Description",
                header: "Description",
                cell: ChartOfAccountsTemplateDescriptionCell,
                minSize: 200,
                maxSize: 1200,
            },
            [ChartOfAccountsTemplatesViewColumn.ENTITIES]: {
                accessorKey: "id",
                name: "Entities",
                header: "Entities",
                cell: ChartOfAccountsTemplateEntitiesCell,
                align: "right",
                minSize: 100,
                maxSize: 160,
            },
            [ChartOfAccountsTemplatesViewColumn.STATUS]: {
                accessorKey: "archivedAt",
                name: "Status",
                header: "Status",
                cell: ChartOfAccountsTemplateStatusCell,
                minSize: 100,
                maxSize: 160,
            },
            [ChartOfAccountsTemplatesViewColumn.ACTIONS]: {
                accessorKey: "id",
                name: "Actions",
                header: "",
                cell: ChartOfAccountsTemplateActionsCell,
                minSize: 140,
                maxSize: 140,
                immutable: true,
                hiddenFromSettings: true,
            },
        },
    };
